'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Themes = undefined;

var _AnalogClock = require('./AnalogClock');

var _AnalogClock2 = _interopRequireDefault(_AnalogClock);

var _themes = require('./themes');

var ClockThemes = _interopRequireWildcard(_themes);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Themes = exports.Themes = ClockThemes;
exports.default = _AnalogClock2.default;